import RoundSwitchItem from './RoundSwitchItem';
import mixpanelTracker from '../utils/mixpanelTracker';

const ticketTypes = {
  oneWay: 'Single Ticket',
  round: 'Round Ticket',
  openTicket: 'Open Ticket',
};

const RoundSwitch = ({
  value,
  onChange,
  showOpenTicket,
  optInReturn,
  discountSingle,
  discountRounded,
  discountOpenTicket,
  redBadge,
}) => {
  if (!showOpenTicket && !optInReturn) return null;

  const handleOnChange = ({ target }) => {
    const ticketTypeValue = target.attributes.value.value;
    mixpanelTracker.trackInterestInTicketTypeEvent({
      section: ticketTypes[ticketTypeValue],
    });
    onChange(ticketTypeValue);
  };

  return (
    <div className="round-switch">
      <RoundSwitchItem
        label="one_way"
        name="trip-type"
        onChange={handleOnChange}
        selected={value}
        value="oneWay"
        discount={discountSingle}
        redBadge={redBadge}
      />
      {optInReturn && (
        <RoundSwitchItem
          label="round_trip"
          name="trip-type"
          onChange={handleOnChange}
          selected={value}
          value="round"
          discount={discountRounded}
          redBadge={redBadge}
        />
      )}
      {showOpenTicket && (
        <RoundSwitchItem
          label="open_ticket"
          name="trip-type"
          onChange={handleOnChange}
          selected={value}
          value="openTicket"
          discount={discountOpenTicket}
          redBadge={redBadge}
        />
      )}
    </div>
  );
};

export default RoundSwitch;
